export default __webpack_public_path__ + "static/media/img_banner.5495a3ad.svg";